// extracted by mini-css-extract-plugin
export default {"base":"QRCode_base__LfReq"};